import Vue from 'www/vue_components'
import Search from 'www/vue_components/common/Search/Search.vue'

const mountElement = document.querySelector('.search-placeholder')

if (mountElement) {
  new Vue({
    el: mountElement,
    components: {
      Search,
    },
  })
}
